import React from 'react'

const ArtProducts = () => {
  return (
    <div>
      Aryt
    </div>
  )
}

export default ArtProducts



